webpackJsonp([4],{

/***/ 152:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_firestore__ = __webpack_require__(349);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_firestore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_firestore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase__ = __webpack_require__(343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__firebase_firestore__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__firebaseConfig__ = __webpack_require__(292);
var _this = this;






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_firestore___default.a);

var firebaseApp = __WEBPACK_IMPORTED_MODULE_2_firebase__["initializeApp"](__WEBPACK_IMPORTED_MODULE_4__firebaseConfig__["a" /* default */]);

// const firestore = firebaseApp.firestore()
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$fb = __WEBPACK_IMPORTED_MODULE_2_firebase__;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$db = __WEBPACK_IMPORTED_MODULE_2_firebase__["firestore"]();

var signUserIn = function signUserIn(_ref, payload) {
  var commit = _ref.commit;

  commit('setLoading', true);
  commit('clearError');
  console.log('fbinit');
  console.log(_this.$fb);
  _this.$fb.auth().signInWithEmailAndPassword(payload.email, payload.password).then(function (user) {
    console.log(user.uid);
    _this.$db.collection('userMeta').where('userId', '==', user.uid).get().then(function (querySnapshot) {
      _this.loading = false;
      querySnapshot.forEach(function (doc) {
        if (doc.data().approved) {
          var newUser = {
            'id': user.uid,
            'firstName': doc.data().firstName,
            'lastName': doc.data().lastName,
            'email': doc.data().email,
            'telephone': doc.data().telephone,
            'address1': doc.data().address1,
            'address2': doc.data().address2,
            'town': doc.data().town,
            'county': doc.data().county,
            'postcode': doc.data().postcode
          };
          _this.$store.dispatch('setUser', newUser);
        } else {
          console.log('your are not approved');
        }
      });
    }).catch(function (error) {
      console.log(error);
    });
  }).catch(function (error) {
    console.log(error);
  });
};

/* unused harmony default export */ var _unused_webpack_default_export = ({ firebaseApp: firebaseApp, signUserIn: signUserIn });

/***/ }),

/***/ 153:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_UserList__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_UserList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__views_UserList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_IssueRequest__ = __webpack_require__(353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_IssueRequest___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__views_IssueRequest__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_IssueType__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_IssueType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__views_IssueType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__auth_guard__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__auth_guard_admin__ = __webpack_require__(293);


// const Profile = () => import('@/components/User/Profile')
var Signup = function Signup() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 369));
};
var Signin = function Signin() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 368));
};
var Password = function Password() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 367));
};






__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Signin',
    component: Signin
  }, {
    path: '/password',
    name: 'Password',
    component: Password
  }, {
    path: '/issue-request/:type',
    name: 'issuerequest',
    component: __WEBPACK_IMPORTED_MODULE_3__views_IssueRequest___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_5__auth_guard__["a" /* default */]
  }, {
    path: '/issue-type',
    name: 'issuetype',
    component: __WEBPACK_IMPORTED_MODULE_4__views_IssueType___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_5__auth_guard__["a" /* default */]
  }, {
    path: '/user-list',
    name: 'user-list',
    component: __WEBPACK_IMPORTED_MODULE_2__views_UserList___default.a,
    beforeEnter: __WEBPACK_IMPORTED_MODULE_6__auth_guard_admin__["a" /* default */]
  },
  // {
  //   path: '/profile',
  //   name: 'Profile',
  //   component: Profile,
  //   beforeEnter: AuthGuard
  // },
  {
    path: '/signup',
    name: 'Signup',
    component: Signup
  }],
  mode: 'history'
}));

/***/ }),

/***/ 154:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 156:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(335)
}
var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(299),
  /* template */
  __webpack_require__(356),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 290:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EventBus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);

var EventBus = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

/***/ }),

/***/ 291:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_firebase_firebaseInit__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_moment__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vee_validate__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__router__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mixins_shared__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.










// Vue.use(Vuetify)
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vee_validate__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_moment___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin(__WEBPACK_IMPORTED_MODULE_8__mixins_shared__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a, {
  theme: {
    primary: '#bacf19',
    secondary: '#484545',
    accent: '#bacf19',
    error: '#c50f0f'
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_7__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_6__store__["a" /* store */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a },
  created: function created() {
    var _this = this;

    this.$fb.auth().onAuthStateChanged(function (user) {
      if (user) {
        _this.$db.collection('userMeta').doc(user.uid).get().then(function (doc) {
          _this.loading = false;
          if (doc.data().approved) {
            var newUser = {
              'id': user.uid,
              'firstName': doc.data().firstName,
              'lastName': doc.data().lastName,
              'email': doc.data().email,
              'telephone': doc.data().telephone,
              'role': doc.data().role,
              'address1': doc.data().address1,
              'address2': doc.data().address2,
              'town': doc.data().town,
              'county': doc.data().county,
              'postcode': doc.data().postcode
            };
            _this.$store.dispatch('signUserIn', newUser);
          } else {
            _this.$fb.auth().signOut();
            _this.$store.dispatch('logout');
            _this.$router.push('/');
          }
        }).catch(function (error) {
          console.log(error);
          _this.loading = false;
          _this.$fb.auth().signOut();
          _this.$store.dispatch('logout');
          _this.$router.push('/');
        });
      }
    });
  }
});

/***/ }),

/***/ 292:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  apiKey: 'AIzaSyDi1urNTTKB5K2Bo1j8lDnv9ITYHptaGqA',
  authDomain: 'propertyfirst-ee59e.firebaseapp.com',
  databaseURL: 'https://propertyfirst-ee59e.firebaseio.com',
  projectId: 'propertyfirst-ee59e',
  storageBucket: 'propertyfirst-ee59e.appspot.com',
  messagingSenderId: '648638012557'
});

/***/ }),

/***/ 293:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(61);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user && __WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user.role === 'Admin') {
    next();
  } else {
    next('/');
  }
});

/***/ }),

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(61);


/* harmony default export */ __webpack_exports__["a"] = (function (to, from, next) {
  if (__WEBPACK_IMPORTED_MODULE_0__store__["a" /* store */].getters.user) {
    next();
  } else {
    next('/');
  }
});

/***/ }),

/***/ 295:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  notifications: []
};
var getters = {
  notifications: function notifications(state) {
    return state.notifications;
  }
};
var mutations = {
  add_Notification: function add_Notification(state, payload) {
    var newNotification = {
      text: payload.text,
      color: payload.color
    };
    state.notifications = newNotification;
  }
};
var actions = {
  addNotification: function addNotification(context, payload) {
    context.commit('add_Notification', payload);
  }
};
/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  mutations: mutations,
  actions: actions
});

/***/ }),

/***/ 296:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    search: null
  },
  mutations: {
    setSearch: function setSearch(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    addSearch: function addSearch(_ref, newSearch) {
      var commit = _ref.commit;

      commit('setSearch', newSearch);
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;

      commit('setUser', null);
    }
  },
  getters: {
    getSearch: function getSearch(state) {
      return state.search;
    }
  }
});

/***/ }),

/***/ 297:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    loading: false,
    error: null
  },
  mutations: {
    setLoading: function setLoading(state, payload) {
      state.loading = payload;
    },
    setError: function setError(state, payload) {
      state.error = payload;
    },
    clearError: function clearError(state) {
      state.error = null;
    }
  },
  actions: {
    clearError: function clearError(_ref) {
      var commit = _ref.commit;

      commit('clearError');
    }
  },
  getters: {
    loading: function loading(state) {
      return state.loading;
    },
    error: function error(state) {
      return state.error;
    }
  }
});

/***/ }),

/***/ 298:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  state: {
    user: null
  },
  mutations: {
    setUser: function setUser(state, payload) {
      state.user = payload;
    }
  },
  actions: {
    signUserUp: function signUserUp(_ref, newUser) {
      var commit = _ref.commit;

      commit('setUser', newUser);
    },
    signUserIn: function signUserIn(_ref2, newUser) {
      var commit = _ref2.commit;

      commit('setUser', newUser);
    },
    autoSignIn: function autoSignIn(_ref3, payload) {
      var commit = _ref3.commit;

      commit('setUser', {
        id: payload.uid,
        name: payload.displayName,
        email: payload.email,
        photoUrl: payload.photoURL
      });
    },
    logout: function logout(_ref4) {
      var commit = _ref4.commit;

      commit('setUser', null);
    }
  },
  getters: {
    user: function user(state) {
      return state.user;
    }
  }
});

/***/ }),

/***/ 299:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Menu__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_layout_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_layout_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_ToolBar__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_layout_ToolBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_layout_ToolBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_notification__ = __webpack_require__(352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_shared_notification___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_shared_notification__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  // mounted: {
  // },
  data: function data() {
    return {
      show: false,
      dialog: false,
      drawer: null,
      bottomNav: 3
    };
  },

  methods: {
    drawerStatusCatch: function drawerStatusCatch(status) {
      this.drawer = status;
    }
  },
  props: {
    source: String
  },
  components: {
    'app-menu': __WEBPACK_IMPORTED_MODULE_0__components_layout_Menu___default.a,
    'app-toolbar': __WEBPACK_IMPORTED_MODULE_1__components_layout_ToolBar___default.a,
    'app-notification': __WEBPACK_IMPORTED_MODULE_2__components_shared_notification___default.a
  }
});

/***/ }),

/***/ 300:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import wpApi from '../../modules/api/app.service'

/* harmony default export */ __webpack_exports__["default"] = ({
  mounted: function mounted() {
    // this.getMenu()
  },
  data: function data() {
    return {
      menu: [],
      loaded: false,
      menuId: 1
    };
  },

  computed: {
    menuItems: function menuItems() {
      var menuItems = [{ icon: 'work', text: 'User List', action: '/user-list' }, { icon: 'work', text: 'Issue Request', action: '/issue-type'
        // {
        //   icon: 'keyboard_arrow_up',
        //   'icon-alt': 'keyboard_arrow_down',
        //   text: 'Labels',
        //   model: true,
        //   children: [
        //     { icon: 'add', text: 'Create label', link: '/signup' }
        //   ]
        // },
        // {
        //   icon: 'keyboard_arrow_up',
        //   'icon-alt': 'keyboard_arrow_down',
        //   text: 'More',
        //   model: false,
        //   children: [
        //     { text: 'Import' },
        //     { text: 'Export' },
        //     { text: 'Print' },
        //     { text: 'Undo changes' },
        //     { text: 'Other contacts' }
        //   ]
        // },
        // { icon: 'settings', text: 'Settings', link: '/signup' },
        // { icon: 'chat_bubble', text: 'Send feedback', link: '/signup' },
        // { icon: 'help', text: 'Help', link: '/signup' },
        // { icon: 'phonelink', text: 'App downloads', link: '/signup' },
        // { icon: 'keyboard', text: 'Go to the old version', link: '/signup' }
      }];
      return menuItems;
    }
  },
  methods: {
    // getMenu () {
    //   const self = this
    //   self.loaded = false
    //   wpApi.getMenu(this.menuId).then((menu) => {
    //     console.log(menu)
    //     this.menu = menu
    //     this.loaded = true
    //   }).catch(error => {
    //     console.log(error)
    //   })
    // }
  }
});

/***/ }),

/***/ 301:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_shared__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  mixin: [__WEBPACK_IMPORTED_MODULE_0__mixins_shared__["a" /* default */]],
  props: ['drawer'],
  data: function data() {
    return {
      search: null,
      localDrawer: this.drawer,
      query: null,
      user: this.$store.getters.user
    };
  },

  watch: {
    drawer: function drawer(newVal, oldVal) {
      this.localDrawer = newVal;
    }
  },
  methods: {
    hideSearch: function hideSearch() {
      this.search = true;
    },
    onLogout: function onLogout() {
      this.$fb.auth().signOut();
      this.$store.dispatch('logout');
      this.$router.push('/');
    },
    showHideDrawer: function showHideDrawer() {
      this.localDrawer = !this.localDrawer;
      this.$emit('drawerStatus', this.localDrawer);
    },
    searchQuery: function searchQuery() {
      this.$router.push({ name: 'search', params: { query: this.query } });
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 302:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(151);

//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notification',
  data: function data() {
    return {
      notificationText: '',
      notificationColor: '',
      notification: false
    };
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* mapGetters */])({
    notifications: 'notifications'
  })),
  watch: {
    notifications: function notifications(newNotification, oldNotification) {
      var _this = this;

      this.notification = false;
      setTimeout(function () {
        _this.notificationText = newNotification.text;
        _this.notificationColor = newNotification.color;
        _this.notification = true;
      }, 250);
    }
  }
});

/***/ }),

/***/ 303:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_shared__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import firebaseApp from '../modules/firebase/firebaseInit'



/* harmony default export */ __webpack_exports__["default"] = ({
  mixin: [__WEBPACK_IMPORTED_MODULE_0__mixins_shared__["a" /* default */]],
  $_veeValidate: {
    validator: 'new'
  },
  mounted: function mounted() {
    this.$validator.localize('en', this.dictionary);
  },

  name: 'issuerequest',
  data: function data() {
    return {
      finished: false,
      loading: false,
      step: 0,
      switchApp: false,
      applianceType: '',
      appliance: false,
      applianceSerial: '',
      applianceMake: '',
      issueText: '',
      contactName: this.currentUser().firstName + ' ' + this.currentUser().lastName,
      tel: this.currentUser().telephone,
      tel2: '',
      email: this.currentUser().email,
      address1: this.currentUser().address1,
      address2: this.currentUser().address2,
      town: this.currentUser().town,
      county: this.currentUser().county,
      postcode: this.currentUser().postcode,
      dayTime: '',
      imageUrl: '',
      consent: null,
      permission: null,
      image: null,
      uploadTask: '',
      progressUpload: 0,
      showProgress: false,
      downloadURL: ''
    };
  },

  methods: {
    submitForm: function submitForm(scope) {
      var _this = this;

      if (scope === 'form-3') {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            _this.request();
          }
        });
      } else {
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            _this.step++;
          }
        });
      }
    },
    toggleApp: function toggleApp() {
      this.appliance = !this.appliance;
    },
    goBack: function goBack() {
      this.step--;
    },
    onPickFile: function onPickFile() {
      this.$refs.fileInput.click();
    },

    // onFilePicked (event) {
    //   this.showProgress = true
    //   const files = event.target.files
    //   let fileName = files[0].name
    //   if (fileName.lastIndexOf('.') <= 0) {
    //     return alert('valid file')
    //   }
    //   let fileReader = new FileReader()
    //   fileReader.addEventListener('load', () => {
    //     // this.imageUrl = fileReader.result
    //   })
    //   fileReader.readAsDataURL(files[0])
    //   const name = Math.random().toString(36).substr(2, 9)
    //   const ext = fileName.slice(fileName.lastIndexOf('.'))
    //   this.uploadTask = this.$fb.storage().ref('images/' + name + ext).put(files[0])
    //   this.uploadTask.then(snapshot => {
    //     this.imageUrl = this.uploadTask.snapshot.downloadURL
    //     // this.downloadURL = this.uploadTask.snapshot.downloadURL
    //     this.showProgress = false
    //   })
    //   .catch(e => {
    //     this.addNotification({text: 'An Error Occurred, try again later', color: 'error'})
    //     this.showProgress = false
    //   })
    // },
    onFilePicked: function onFilePicked(e) {
      var _this2 = this;

      this.showProgress = true;
      var files = e.target.files;
      var fileName = files[0].name;
      var reader = new FileReader();
      reader.readAsDataURL(e.target.files[0]);
      reader.onload = function (event) {
        var img = new Image();
        img.src = event.target.result;
        img.onload = function () {
          var elem = document.createElement('canvas');
          var width = 1000;
          var scaleFactor = width / img.width;
          elem.width = width;
          elem.height = img.height * scaleFactor;
          var ctx = elem.getContext('2d');
          // img.width and img.height will give the original dimensions
          ctx.drawImage(img, 0, 0, width, img.height * scaleFactor);
          ctx.canvas.toBlob(function (blob) {
            var file = new File([blob], fileName, {
              type: 'image/jpeg',
              lastModified: Date.now()
            });
            _this2.uploadTask = _this2.$fb.storage().ref('images/' + name + 'jpg').put(file);
            _this2.uploadTask.then(function (snapshot) {
              _this2.imageUrl = _this2.uploadTask.snapshot.downloadURL;
              // this.downloadURL = this.uploadTask.snapshot.downloadURL
              _this2.showProgress = false;
            }).catch(function (e) {
              _this2.addNotification({ text: 'An Error Occurred, try again later', color: 'error' });
              _this2.showProgress = false;
            });
          }, 'image/jpeg', 1);
        };
        reader.onerror = function (error) {
          return console.log(error);
        };
      };
    },
    onLogout: function onLogout() {
      this.finished = false;
      this.resetData();
      this.$fb.auth().signOut();
      this.$store.dispatch('logout');
      this.$router.push('/');
    },
    resetData: function resetData() {
      this.step = 0;
      this.switchApp = false;
      this.applianceType = '';
      this.appliance = false;
      this.applianceSerial = '';
      this.applianceMake = '';
      this.issueText = '';
      this.dayTime = '';
      this.imageUrl = '';
      this.consent = null;
      this.image = null;
    },
    request: function request() {
      var _this3 = this;

      this.loading = true;
      var body = {
        appCategory: this.$route.params.type,
        switchApp: this.switchApp,
        applianceType: this.applianceType,
        appliance: this.appliance,
        applianceSerial: this.applianceSerial,
        applianceMake: this.applianceMake,
        issueText: this.issueText,
        contactName: this.contactName,
        permission: this.permission,
        consent: this.consent,
        tel: this.tel,
        tel2: this.tel2,
        email: this.email,
        address1: this.address1,
        address2: this.address2,
        town: this.town,
        county: this.county,
        postcode: this.postcode,
        dayTime: this.dayTime,
        imageUrl: this.imageUrl
      };
      this.$fb.auth().currentUser.getIdToken().then(function (token) {
        __WEBPACK_IMPORTED_MODULE_1_axios___default()({
          method: 'post',
          data: body,
          url: 'https://us-central1-propertyfirst-ee59e.cloudfunctions.net/app/request',
          headers: { 'Authorization': 'Bearer ' + token }
        }).then(function (response) {
          // JSON responses are automatically parsed
          _this3.loading = false;
          _this3.finished = true;
          // this.addNotification({text: 'Your request has been sent. We will be in touch shortly.', color: 'success'})
          _this3.resetData();
        }).catch(function (e) {
          _this3.addNotification({ text: 'An Error Occurred, try again later', color: 'error' });
          console.log(e);
          _this3.loading = false;
        });
      });
    }
  },
  watch: {
    uploadTask: function uploadTask() {
      var _this4 = this;

      this.uploadTask.on('state_changed', function (sp) {
        _this4.progressUpload = Math.floor(sp.bytesTransferred / sp.totalBytes * 100);
      });
    }
  }
});

/***/ }),

/***/ 304:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_bus_js__ = __webpack_require__(290);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//  import firebaseApp from '../modules/firebase/firebaseInit'



/* harmony default export */ __webpack_exports__["default"] = ({
  $_veeValidate: {
    validator: 'new'
  },
  mounted: function mounted() {
    this.$validator.localize('en', this.dictionary);
  },

  name: 'issuerequest',
  data: function data() {
    return {
      step: 0,
      firstName: '',
      lastName: '',
      imageUrl: '',
      image: null,
      uploadTask: '',
      progressUpload: 0,
      showProgress: false,
      downloadURL: ''
    };
  },

  methods: {
    typeClicked: function typeClicked(type) {
      __WEBPACK_IMPORTED_MODULE_0__event_bus_js__["a" /* EventBus */].$emit('type', type);
      // this.$router.push('/issue-type')
      this.$router.push({ name: 'issuerequest', params: { type: type } });
      // this.$router.push({ path: '/issue-type' })
    }
  }
});

/***/ }),

/***/ 305:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_shared__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'users',
  mixin: [__WEBPACK_IMPORTED_MODULE_0__mixins_shared__["a" /* default */]],
  data: function data() {
    return {
      search: '',
      items: [],
      loading: true,
      pagination: {
        sortBy: 'name'
      },
      selected: [],
      headers: [{
        text: 'Name',
        align: 'left',
        value: 'lastName'
      }, { text: 'Email', value: 'email', sortable: true }, { text: 'Telephone', value: 'telephone', sortable: true }, { text: 'Post Code', value: 'postcode', sortable: true }, { text: 'Actions', value: 'name', sortable: false }]
    };
  },

  methods: {
    loadUsers: function loadUsers() {
      var _this = this;

      this.$binding('items', this.$db.collection('userMeta')).then(function (items) {
        _this.loading = false;
      }).catch(function (error) {
        console.error(error);
      });
    },
    deleteUser: function deleteUser(item) {
      var _this2 = this;

      var index = this.items.indexOf(item);
      confirm('Are you sure you want to delete this user?') && this.items.splice(index, 1);
      this.$db.collection('userMeta').doc(item['.key']).delete().then(function () {
        _this2.addNotification({ text: 'Document successfully deleted!', color: 'success' });
        _this2.loading = false;
      }).catch(function (error) {
        _this2.addNotification({ text: 'Error deleting user', color: 'error' });
        console.error(error);
      });
    },
    approveUser: function approveUser(item, isApproved) {
      var _this3 = this;

      isApproved = !isApproved;
      this.$db.collection('userMeta').doc(item['.key']).update({
        approved: isApproved
      }).catch(function (error) {
        _this3.addNotification({ text: 'Error editing user', color: 'error' });
        console.error(error);
      });
    },
    toggleAll: function toggleAll() {
      if (this.selected.length) this.selected = [];else this.selected = this.items.slice();
    },
    changeSort: function changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    }
  },
  mounted: function mounted() {
    this.loadUsers();
  }
});

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 338:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 339:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(300),
  /* template */
  __webpack_require__(357),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(338)
}
var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(301),
  /* template */
  __webpack_require__(361),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(302),
  /* template */
  __webpack_require__(359),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 353:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(339)
}
var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(303),
  /* template */
  __webpack_require__(362),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-f7fda6a0",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(336)
}
var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(304),
  /* template */
  __webpack_require__(358),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2ecd3269",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(337)
}
var Component = __webpack_require__(22)(
  /* script */
  __webpack_require__(305),
  /* template */
  __webpack_require__(360),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6ccd93c3",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 356:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(_vm.userIsAdmin()) ? _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "clipped": _vm.$vuetify.breakpoint.lgAndUp,
      "app": ""
    },
    on: {
      "input": _vm.drawerStatusCatch
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('app-menu')], 1) : _vm._e(), _vm._v(" "), _c('app-toolbar', {
    attrs: {
      "drawer": _vm.drawer
    },
    on: {
      "drawerStatus": _vm.drawerStatusCatch
    }
  }), _vm._v(" "), _c('v-content', [_c('keep-alive', [_c('router-view', {
    key: _vm.$route.path
  })], 1)], 1), _vm._v(" "), _c('app-notification')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 357:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-list', [_vm._l((_vm.menuItems), function(item) {
    return [(item.heading) ? _c('v-layout', {
      key: item.heading,
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs6": ""
      }
    }, [(item.heading) ? _c('v-subheader', [_vm._v("\n                " + _vm._s(item.heading) + "\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-center",
      attrs: {
        "xs6": ""
      }
    }, [_c('a', {
      staticClass: "body-2 black--text",
      attrs: {
        "href": "#!"
      }
    }, [_vm._v("EDIT")])])], 1) : (item.children) ? _c('v-list-group', {
      key: item.text,
      attrs: {
        "prepend-icon": item.model ? item.icon : item['icon-alt'],
        "append-icon": "",
        "value": "item.active"
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "to": item.action
      }
    }, [_vm._v("\n                  " + _vm._s(item.text) + "\n                ")])], 1)], 1), _vm._v(" "), _vm._l((item.children), function(child, i) {
      return _c('v-list-tile', {
        key: i,
        on: {
          "click": function($event) {}
        }
      }, [(child.icon) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(child.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                  " + _vm._s(child.text) + "\n                ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      key: item.text,
      attrs: {
        "to": item.action
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                " + _vm._s(item.text) + "\n              ")])], 1)], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),

/***/ 358:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticStyle: {
      "padding-top": "30px"
    },
    attrs: {
      "grid-list-md": "",
      "text-xs-center": ""
    }
  }, [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('h4', [_vm._v("Please select the category that best describes your issue.")])])], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "component-fade",
      "appear": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Plumbing')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/water.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Plumbing")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Heating')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/heating.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Heating")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Electric')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/electric.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Electric")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Appliances')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/appliances.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Appliances")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Exterior')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/exterior.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Exterior")])])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "type",
    attrs: {
      "dark": "",
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.typeClicked('Interior')
      }
    }
  }, [_c('v-card-text', {
    staticClass: "px-0"
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/interior.png"
    }
  }), _vm._v(" "), _c('p', [_vm._v("Interior")])])], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 359:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-snackbar', {
    attrs: {
      "color": _vm.notificationColor
    },
    model: {
      value: (_vm.notification),
      callback: function($$v) {
        _vm.notification = $$v
      },
      expression: "notification"
    }
  }, [_vm._v(_vm._s(_vm.notificationText) + " "), _c('v-btn', {
    attrs: {
      "dark": "",
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.notification = false
      }
    }
  }, [_vm._v("Close")])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 36:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    addNotification: function addNotification(notification) {
      this.$store.dispatch('addNotification', notification);
    },
    userIsAuthenticated: function userIsAuthenticated() {
      return this.$store.getters.user !== null && this.$store.getters.user !== undefined;
    },
    userIsAdmin: function userIsAdmin() {
      return this.$store.getters.user && this.$store.getters.user.role === 'Admin';
    },
    currentUser: function currentUser() {
      return this.$store.getters.user;
    }
  }
});

/***/ }),

/***/ 360:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('h1', [_vm._v("Users")]), _vm._v(" "), [_c('v-card', [_c('v-card-title', [_vm._v("\n      All Registered Users\n      "), _c('v-spacer'), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "label": "Search",
      "single-line": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.items,
      "search": _vm.search,
      "loading": _vm.loading,
      "item-key": "name",
      "select-all": "",
      "pagination": _vm.pagination
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "headers",
      fn: function(props) {
        return [_c('tr', _vm._l((props.headers), function(header) {
          return _c('th', {
            key: header.text,
            class: ['column sortable', _vm.pagination.descending ? 'desc' : 'asc', header.value === _vm.pagination.sortBy ? 'active' : ''],
            on: {
              "click": function($event) {
                _vm.changeSort(header.value)
              }
            }
          }, [_c('v-icon', {
            attrs: {
              "small": ""
            }
          }, [_vm._v("arrow_upward")]), _vm._v("\n          " + _vm._s(header.text) + "\n        ")], 1)
        }))]
      }
    }, {
      key: "items",
      fn: function(props) {
        return [_c('tr', {
          attrs: {
            "active": props.selected
          },
          on: {
            "click": function($event) {
              props.selected = !props.selected
            }
          }
        }, [_c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.firstName) + " " + _vm._s(props.item.lastName))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.email))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.telephone))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [_vm._v(_vm._s(props.item.postcode))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-left"
        }, [(!props.item.approved) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "ripple": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.approveUser(props.item, props.item.approved)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "pink"
          }
        }, [_vm._v("block")])], 1) : _vm._e(), _vm._v(" "), (props.item.approved) ? _c('v-btn', {
          staticClass: "mx-0",
          attrs: {
            "ripple": "",
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.approveUser(props.item, props.item.approved)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "teal"
          }
        }, [_vm._v("block")])], 1) : _vm._e()], 1)])]
      }
    }]),
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_c('v-progress-linear', {
    attrs: {
      "slot": "progress",
      "color": "blue",
      "indeterminate": ""
    },
    slot: "progress"
  })], 1)], 1)]], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 361:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tool-bar"
  }, [_c('v-toolbar', {
    staticClass: "elevation-2 pf-toolbar",
    attrs: {
      "color": "secondary",
      "dark": "",
      "app": "",
      "clipped-left": "",
      "fixed": ""
    }
  }, [_c('v-toolbar-title', {
    staticClass: "ml-0",
    staticStyle: {
      "width": "300px"
    }
  }, [(_vm.userIsAdmin()) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.showHideDrawer($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "logo-span"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": "https://d1dwubzia1nkxt.cloudfront.net/property-first.png"
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "margin-left": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("mdi-search")])], 1)], 1), _vm._v(" "), _c('v-toolbar-items', [(_vm.userIsAuthenticated()) ? _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("person")]), _vm._v("  " + _vm._s(_vm.currentUser().firstName) + "\n    ")], 1), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-title', {
    staticClass: "cursor",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onLogout($event)
      }
    }
  }, [_vm._v("Logout")])], 1)], 1)], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 362:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [(_vm.finished) ? _c('div', [_c('h2', [_vm._v("Your request has been sent. We will be in touch shortly.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "cursor",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onLogout($event)
      }
    }
  }, [_vm._v("Log Out")])], 1) : _vm._e(), _vm._v(" "), (!_vm.finished) ? _c('v-stepper', {
    staticClass: "pfStepper",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('h3', {
    staticClass: "issueH"
  }, [_vm._v("Issue: " + _vm._s(_vm.$route.params.type))]), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.step > 1
    }
  }, [_vm._v("\n          About the Issue\n           "), _c('small', [_vm._v("Please provide as much information as possible")])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-form', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "data-vv-scope": "form-1"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Is your issue related to an appliance?"
    },
    model: {
      value: (_vm.switchApp),
      callback: function($$v) {
        _vm.switchApp = $$v
      },
      expression: "switchApp"
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "component-fade",
      "appear": ""
    }
  }, [(_vm.switchApp) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    attrs: {
      "box": "",
      "hint": "eg TV, Boiler etc",
      "label": "Type of appliance",
      "error-messages": _vm.errors.collect('applianceType'),
      "data-vv-name": "applianceType",
      "required": "",
      "data-vv-scope": "form-1"
    },
    model: {
      value: (_vm.applianceType),
      callback: function($$v) {
        _vm.applianceType = $$v
      },
      expression: "applianceType"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "component-fade",
      "appear": ""
    }
  }, [(_vm.switchApp) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    attrs: {
      "box": "",
      "label": "Appliance Make",
      "error-messages": _vm.errors.collect('applianceMake'),
      "data-vv-name": "applianceMake",
      "required": "",
      "data-vv-scope": "form-1"
    },
    model: {
      value: (_vm.applianceMake),
      callback: function($$v) {
        _vm.applianceMake = $$v
      },
      expression: "applianceMake"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "component-fade",
      "appear": ""
    }
  }, [(_vm.switchApp) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    attrs: {
      "box": "",
      "hint": "If you can see a serial number, what is it?",
      "label": "Appliance serial number",
      "error-messages": _vm.errors.collect('applianceSerial'),
      "data-vv-name": "applianceSerial",
      "required": "",
      "data-vv-scope": "form-1"
    },
    model: {
      value: (_vm.applianceSerial),
      callback: function($$v) {
        _vm.applianceSerial = $$v
      },
      expression: "applianceSerial"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:3000'),
      expression: "'required|max:3000'"
    }],
    attrs: {
      "box": "",
      "label": "Description of repair / issue",
      "hint": "Please describe the issue in as much detail as possible",
      "error-messages": _vm.errors.collect('issueText'),
      "auto-grow": "",
      "data-vv-name": "issueText",
      "required": "",
      "data-vv-scope": "form-1"
    },
    model: {
      value: (_vm.issueText),
      callback: function($$v) {
        _vm.issueText = $$v
      },
      expression: "issueText"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitForm('form-1')
      }
    }
  }, [_vm._v("Continue")])], 1)], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.step > 2
    }
  }, [_vm._v("Upload an photo")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "component-fade",
      "appear": ""
    }
  }, [(_vm.imageUrl) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('img', {
    staticStyle: {
      "height": "150px"
    },
    attrs: {
      "src": _vm.imageUrl
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "raised": ""
    },
    on: {
      "click": _vm.onPickFile
    }
  }, [_vm._v("Upload Image")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFilePicked
    }
  }), _vm._v(" "), (_vm.showProgress) ? _c('v-progress-linear', {
    model: {
      value: (_vm.progressUpload),
      callback: function($$v) {
        _vm.progressUpload = $$v
      },
      expression: "progressUpload"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack($event)
      }
    }
  }, [_vm._v("Go Back")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3",
      "complete": _vm.step > 3
    }
  }, [_vm._v("Contact details and consent")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-form', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "data-vv-scope": "form-3"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:60'),
      expression: "'required|max:60'"
    }],
    attrs: {
      "box": "",
      "label": "Contact Name",
      "error-messages": _vm.errors.collect('contactName'),
      "data-vv-name": "applianceType",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.contactName),
      callback: function($$v) {
        _vm.contactName = $$v
      },
      expression: "contactName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "box": "",
      "hint": "What is the best telephone number to contact you on?",
      "label": "Telephone Number",
      "error-messages": _vm.errors.collect('tel'),
      "data-vv-name": "tel",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    attrs: {
      "box": "",
      "hint": "What is an alternative number to contact you on?",
      "label": "Additional Number",
      "error-messages": _vm.errors.collect('tel2'),
      "data-vv-name": "tel2",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.tel2),
      callback: function($$v) {
        _vm.tel2 = $$v
      },
      expression: "tel2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    attrs: {
      "box": "",
      "label": "Access times available / arrangements",
      "hint": "Please give a good day and time for the repair work to be carried out",
      "error-messages": _vm.errors.collect('dayTime'),
      "data-vv-name": "dayTime",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.dayTime),
      callback: function($$v) {
        _vm.dayTime = $$v
      },
      expression: "dayTime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-checkbox', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "I give permission for third party contrators to access the property using management keys. ",
      "error-messages": _vm.errors.collect('permission'),
      "data-vv-name": "permission",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.permission),
      callback: function($$v) {
        _vm.permission = $$v
      },
      expression: "permission"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-checkbox', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "I consent to my personal details being passed on to third party contrators to complete the repair work.",
      "error-messages": _vm.errors.collect('consent'),
      "data-vv-name": "consent",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.consent),
      callback: function($$v) {
        _vm.consent = $$v
      },
      expression: "consent"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "ripple": "",
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitForm('form-3')
      }
    }
  }, [_vm._v("Send Request")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack($event)
      }
    }
  }, [_vm._v("Go Back")])], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 61:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__user__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__search__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__shared__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__notifications__ = __webpack_require__(295);







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["b" /* default */].Store({
  modules: {
    user: __WEBPACK_IMPORTED_MODULE_2__user__["a" /* default */],
    shared: __WEBPACK_IMPORTED_MODULE_4__shared__["a" /* default */],
    search: __WEBPACK_IMPORTED_MODULE_3__search__["a" /* default */],
    notofications: __WEBPACK_IMPORTED_MODULE_5__notifications__["a" /* default */]
  }
});

/***/ })

},[291]);


// WEBPACK FOOTER //
// static/js/app.c7d8e1cbaccd20af62f7.js